// src/Contact.jsx

function Contact() {
  return (
    <section id="contato" className="section section--alt">
      <div className="section-inner contact-layout">
        <div className="contact-text">
          <h2>Vamos conversar?</h2>
          <p>
            Se você quer fortalecer projetos de inovação, metodologias ativas,
            cultura maker ou transformação digital na sua instituição, eu posso
            te ajudar a desenhar caminhos possíveis – olhando para o contexto
            real da sua escola ou rede.
          </p>
          <p>
            Podemos pensar juntas(os) em formações, acompanhamento de projetos,
            hackathons educacionais, sequências didáticas e outras estratégias
            que façam sentido para a sua realidade.
          </p>
        </div>

        <div className="contact-card">
          <h3>Fale comigo</h3>
          <p>
            📩 <strong>E-mail:</strong><br />
            <a href="mailto:karen@tenapratica.com.br">
              karen@tenapratica.com.br
            </a>
          </p>

          <p className="contact-small">
            Envie uma mensagem contando um pouco sobre o contexto da sua escola
            ou rede e o que você gostaria de construir. Eu retorno o contato
            para continuarmos a conversa.
          </p>

       

        </div>
      </div>
    </section>
  );
}

export default Contact;
